import { render } from "./CommonLoading.vue?vue&type=template&id=bed2f47c"
import script from "./CommonLoading.vue?vue&type=script&lang=js"
export * from "./CommonLoading.vue?vue&type=script&lang=js"

import exportComponent from "F:\\projects\\Cloutlayer\\Cloutlayer\\Source\\webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__